import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";

export default function PatientLogin() {
  const nav = useNavigate();
  const { token, role } = useApp();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sp] = useSearchParams();
  const nextPath = sp.get("next") || "/paciente/panel";

  useEffect(() => {
    if (token && role === "patient") nav(nextPath, { replace: true });
  }, [token, role, nav, nextPath]);

  const submit = async () => {
    if (!email) return toast.error("Ingresa tu email");
    setLoading(true);
    try {
      await api.post("/patient/magic-link", { email });
      setSent(true);
    } catch (e) { toast.error("Error al enviar"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14">
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-6 sm:p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="mx-auto w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-3">
                <CheckCircle2 className="text-emerald-600" size={30}/>
              </div>
              <h1 className="text-xl font-bold text-slate-900">Revisa tu email</h1>
              <p className="text-sm text-slate-600 mt-2">
                Enviamos un enlace de acceso a <strong>{email}</strong>. Es válido 24 horas.
              </p>
              <Button data-testid="patient-back-home" onClick={() => nav("/")} variant="outline" className="mt-5">
                Volver al inicio
              </Button>
            </div>
          ) : (
            <>
              <div className="w-11 h-11 rounded-xl bg-blue-600 flex items-center justify-center mb-4">
                <Mail className="text-white" size={22}/>
              </div>
              <h1 className="text-2xl font-bold text-slate-900">Mi espacio paciente</h1>
              <p className="text-sm text-slate-500 mt-1">
                Ingresa tu email y te enviaremos un enlace mágico. Sin contraseñas.
              </p>
              <div className="mt-5">
                <Label>Email</Label>
                <Input data-testid="patient-email-input" type="email" value={email}
                       onChange={e => setEmail(e.target.value)} placeholder="tu@email.com"/>
              </div>
              <Button data-testid="patient-magic-btn" onClick={submit} disabled={loading}
                      className="w-full mt-5 h-11 bg-blue-600 hover:bg-blue-700">
                Recibir enlace por email
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
